import KV from '../../_static/src/js/top/Sec1_KV'
import Statement from '../../_static/src/js/top/Sec2_Statement'
import Movie from '../../_static/src/js/top/Sec3_Movie'
import AboutUs from '../../_static/src/js/top/Sec5_AboutUs'
import Environment from '../../_static/src/js/top/Sec8_Environment'
import Banner from '../../_static/src/js/top/Banner'

class Top {
  constructor()
  {
    this.modules = [
      KV,
      Movie,
      AboutUs,
      Statement,
      Environment,
      Banner,
    ]
    this.bootstrap()
  }

  bootstrap()
  {
    if(document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.init()
      }, { once: true })
      return
    }

    this.init()
  }
  
  init()
  {
    this.modules.forEach((ModuleClass) => {
      try {
        new ModuleClass()
      }
      catch (error) {
        console.error(`[Top] ${ModuleClass.name} init failed:`, error)
      }
    })
  }
}

new Top()